import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { Box } from "@mui/material";
import { Office365Svg } from "../CommonSvgs";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const gmailSettings = [
  {
    step: 1,
    description: `Go to your Google Account's <b style="color: #016AFF;">Security Settings</b>`,
  },
  {
    step: 2,
    description: `Enable <b style="color: #016AFF;">2-step verification</b>`,
  },
  {
    step: 3,
    description: `Create an <b style="color: #016AFF;">App password</b> <br/> 
      <span style="color: #3B4858;">Select 'Other' for both App and Device.</span>`,
  },
];

const microsoftSetupSteps = [
  {
    step: 1,
    description: `On your computer, log in to your <a style="color: #016AFF;text-decoration:none; font-weight:bold;" href="https://login.microsoftonline.com/common/oauth2/authorize?client_id=69893ee3-dd10-4b1c-832d-4870354be3d8&redirect_uri=https%3A%2F%2Fwww.microsoft.com%2Frpsauth%2Fv2%2Faccount%2Faad%2Fsignincallback&response_type=code%20id_token&scope=openid%20profile&state=OpenIdConnect.AuthenticationProperties%3DuY3DW5Vd6c52hskmvHQMvnmURZ0n4SSHs6R4NMVdJLhuhyggW7ujA5XkwKOqoVXWfszLEvYa1iX5mJKYiYCpTqKcmhYTb24bwjIA1KF7ooYla5Jx1vAea8MXXTUH4zJoxzS3GC0EUfAHWFUczTjD-Jx1usH6Ge2zF9XFHjI_qiQm9gqmPVDSxySauwdQLrYp1AM_Nqzy7u3gTLMJBiINWsuFMNdWl1yUFAQqcjeCKMCzg37hwcbVOI2S_Kv0cICTqlu5OYEmf2iQU6ZZh3rx-5ExfWSo9CzuF1x9ZN5YiTKu8QOeD8GzTtjmg-5SFEjWbRjuOxRt09hApBeOdapNJLUKArmY3wwm79U0Q2I7fexL9LpqvZO3IGurLN-oy1mN8owNsmaTqsjSAS1N20dHUt1CiQdVQyymRcUppQ1t_zUTOpnjUhoOas6mvWOXdQ6mva8Uj_JJ5kNKjO1eN_x_ZN7pPqqGO-dsTv0P5B5YTON_sl7gOQUKnyYrjENbs-t56lx79vTNEf53AYZJutD12g&response_mode=form_post&nonce=638461791136558120.ZmU5MmQ4NzgtNTY3Yy00MGI1LWExYjAtNGM3ZmI2N2I5NzlkZTU3NTVlNWUtY2E5MC00NWRkLWI2YTEtODA2Nzk0NGZhZTIw&msaredir=1&lc=16393&x-client-SKU=ID_NET461&x-client-ver=5.5.0.0" target="_blank">Microsoft Admin center.</a>`,
  },
  {
    step: 2,
    description: `Open <b style="color: #016AFF;">Active Users.</b>`,
  },
  {
    step: 3,
    description: `In the side window, click on <b style="color:#818182;">Mail</b> tab, and then on <b style="color:#818182;">Manage email apps.</b>`,
  },
  {
    step: 4,
    description: `Check the <b style="color:#818182;">Authenticated SMTP</b> box and make sure <b style="color:#818182;">IMAP</b> is checked too.`,
  },
  {
    step: 5,
    description: `Click <b style="color:#818182;">Save Changes.</b>`,
  },
  {
    step: 6,
    description: "Wait for one hour and connect your account to Instantly.",
  },
];

const godaddySetupSteps = [
  {
    step: 1,
    description: `On your computer, log in to your <b style="color: #016AFF;font-weight:bold;">GoDaddy</b> <b style="color:#818182;">account</b>`,
  },
  {
    step: 2,
    description: `Go to <b style="color:#818182;">My Products</b> page.`,
  },
  {
    step: 3,
    description: `Scroll down and go to <b style="color:#818182;">Email and Office </b>section.`,
  },
  {
    step: 4,
    description: "Click Manage All.",
  },
  {
    step: 5,
    description: "Find the user you want to enable SMTP for and click Manage.",
  },
  {
    step: 6,
    description: `Scroll down, click on <b style="color:#818182;">Advanced Settings.</b>`,
  },
  {
    step: 7,
    description: `Click on <b style="color:#818182;">SMTP Authentication</b> - the button will turn from gray to green.`,
  },
  {
    step: 8,
    description:
      "Wait for one hour and proceed to connect the account to Instantly.",
  },
];

const MicrosoftAccountModal = ({
  openSetUpPasswordModal,
  setOpenMicrosoftConnectionModal,
}) => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));

  return (
    <Dialog
      open={openSetUpPasswordModal}
      TransitionComponent={Transition}
      keepMounted
      fullWidth={true}
      maxWidth={"sm"}
      onClose={() => setOpenMicrosoftConnectionModal(false)}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle sx={{ padding: "16px 24px 8px 24px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <Office365Svg />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#000",
                fontSize: "18px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Connect Your Microsoft Account
            </p>
            <span
              style={{
                fontWeight: 600,
                color: "#868686",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                marginTop: "-4px",
              }}
            >
              Office 365 / Outlook
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent
        id="alert-dialog-slide-description"
        sx={{ paddingBottom: "0px" }}
      >
        <Box
          sx={{
            borderBottom: "1px solid #DDD",
            padding: "6px 0px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              fontWeight: 400,
              color: "#000",
              fontSize: "14px",
              letterSpacing: "0.7px",
              fontFamily: "Source Sans 3",
              fontStyle: "normal",
            }}
          >
            First, let's{" "}
            <b
              style={{
                color: "#016AFF",
              }}
            >
              enable SMTP
            </b>{" "}
            access <br /> for your Microsoft account.
          </p>
        </Box>
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            padding: "8px 0px",
          }}
        >
          <div
            style={{
              borderRadius: 5,
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
              padding: "8px 0px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#000",
                fontSize: "18px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                textAlign: "center",
              }}
            >
              Microsoft accounts purchased <br /> directly from Microsoft
            </p>
            <ul
              style={{
                padding: "10px 8px",
                display: "flex",
                flexDirection: "column",
                gap: 8,
                height: "180px",
                overflowY: "auto",
                overscrollBehavior: "contain",
                scrollbarWidth: "thin",
                // scrollbarColor: "#D5DEE1 #FFF",
                WebkitOverflowScrolling: "touch",
              }}
              className="microsoft-scrollbar"
            >
              {microsoftSetupSteps.map((item) => (
                <li
                  style={{
                    listStyleType: "none",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 4,
                    color: "#000",
                    fontSize: "14px",
                    letterSpacing: "0.7px",
                    fontFamily: "Source Sans 3",
                    fontStyle: "normal",
                  }}
                >
                  <span style={{ fontWeight: 700 }}>{item.step}.</span>{" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </li>
              ))}
            </ul>
            <button
              style={{
                alignSelf: "center",
                fontWeight: 400,
                color: "#868686",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                padding: "6px 0px",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Show me how <KeyboardArrowRightIcon />{" "}
            </button>
          </div>
          <div
            style={{
              borderRadius: 5,
              boxShadow:
                "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
              padding: "8px 0px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                fontWeight: 700,
                color: "#000",
                fontSize: "18px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                textAlign: "center",
              }}
            >
              Microsoft accounts purchased <br /> from GoDaddy
            </p>
            <ul
              style={{
                padding: "10px 8px",
                display: "flex",
                flexDirection: "column",
                gap: 8,
                height: "180px",
                overflowY: "auto",
                overscrollBehavior: "contain",
                scrollbarWidth: "thin", // For Firefox
                scrollbarColor: "#A0A0A0 #F4F4F4", // For Firefox
                WebkitOverflowScrolling: "touch",
              }}
            >
              {godaddySetupSteps.map((item) => (
                <li
                  style={{
                    listStyleType: "none",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 4,
                    color: "#000",
                    fontSize: "14px",
                    letterSpacing: "0.7px",
                    fontFamily: "Source Sans 3",
                    fontStyle: "normal",
                  }}
                >
                  <span style={{ fontWeight: 700 }}>{item.step}.</span>{" "}
                  <span
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                </li>
              ))}
            </ul>
            <button
              style={{
                alignSelf: "center",
                fontWeight: 400,
                color: "#868686",
                fontSize: "14px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                padding: "6px 0px",
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              Show me how <KeyboardArrowRightIcon />{" "}
            </button>
          </div>
        </div>
      </DialogContent>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 14,
          padding: "10px 24px",
        }}
      >
        <button
          onClick={() => setOpenMicrosoftConnectionModal(false)}
          style={{
            backgroundColor: "transparent",
            fontWeight: 400,
            color: "#1C485F",
            border: "1px solid #1C485F",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "10px 14px",
            display: "flex",
            alignItems: "center",
            borderRadius: 5,
            gap: 1,
          }}
        >
          Cancel
        </button>
        <button
          onClick={() =>
            window.open(
              `https://mail.coldsender.com/email-marketing/user/get-microsoft-code/${
                userDetails && userDetails.details._id
              }`,
              "_blank"
            )
          }
          style={{
            backgroundColor: "#FF3301",
            fontWeight: 400,
            color: "#FFF",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            padding: "10px 14px",
            borderRadius: 5,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            gap: 2,
          }}
        >
          Continue
        </button>
      </div>
    </Dialog>
  );
};

export default MicrosoftAccountModal;
